(function(){
  var num = -1;
  window.add_participant_form = function() {
    var the_num = num--;
    var form = $('.participant-new').clone();
    form.removeClass('participant-new').addClass('participant-one');
    form.find('input').each(function(i, el){
      el = $(el);
      el.prop('disabled', false);
      el.attr('name', el.attr('name').replace(/\[dummy\]/, '['+the_num+']'));
    });
    form.show();
    $('.participant-new').before(form);
    return false;
  };
})();